import { FC, memo, ReactNode } from "react";

import Column from "apps/website/components/layout/Column/Column";
import { IconSvg } from "apps/website/components/base/Icon/Icon.map";
import Icon from "apps/website/components/base/Icon/Icon";
import TextBody from "apps/website/components/base/Text/TextBody/TextBody";
import TextSubtitle from "apps/website/components/base/Text/TextSubtitle/TextSubtitle";
import Spacer from "apps/website/components/layout/Spacer/Spacer";
import {
  Span,
  BreakpointSpan,
} from "apps/website/components/layout/Column/Column.map";
import { Pill } from "apps/website/components/base/Pill/Pill";

export interface IHorizontalIconTextListItem {
  icon: IconSvg;
  title: string;
  body: string | ReactNode;
  count?: number;
  spans?: Span | BreakpointSpan;
  pills?: string[];
}

const HorizontalIconTextListItem: FC<IHorizontalIconTextListItem> = (props) => (
  <Column
    component="HorizontalIconTextListItem"
    spans={ props.spans }
    tag="li" key={props.title}
    direction="row"
    className="space-x-4"
  >
    <div className="flex items-center justify-center flex-none w-10 h-10">
      <Icon icon={props.icon} size="fit" />
    </div>
    <div>
      <TextSubtitle tag="h3" size={2} data-testid="HorizontalIconTextListItemTitle">
        { props.count ? `${props.count}. ` : null }{ props.title }
      </TextSubtitle>
      <Spacer size="sm" />
      <TextBody size={ 2 } data-testid="HorizontalIconTextListItemBody">{ props.body }</TextBody>
      <Spacer size="sm" />
      <div className="flex flex-wrap w-full gap-2">
        { props.pills?.map((p) => (
          <Pill key={p} label={p} styleOptions={{ bgColor: "green-light", textDisplay: "body" }}></Pill>
        )) }
      </div>
    </div>
  </Column>
);

export default memo(HorizontalIconTextListItem);
